import { jsx as D } from "react/jsx-runtime";
import { forwardRef as y, useId as O, useMemo as u } from "react";
import { r as z } from "./chunks/resolveConfig-BryMA7OT.js";
import $ from "./preset.js";
import { S as R } from "./chunks/react-select.esm-BkMQbR_A.js";
const { theme: r } = z($), a = {
  clearIndicator: (o) => ({
    ...o,
    color: r.colors.neutral[900],
    cursor: "pointer",
    ":hover": {
      color: r.colors.neutral[900]
    }
  }),
  container: (o, n) => ({
    ...o,
    pointerEvents: n.isDisabled && "auto"
  }),
  control: (o, n) => ({
    ...o,
    backgroundColor: r.colors.white,
    borderColor: r.colors.neutral[200],
    ":hover": {
      borderColor: r.colors.neutral[200]
    },
    boxShadow: "none",
    cursor: n.isDisabled && "not-allowed",
    fontSize: r.fontSize.base,
    ...(n.menuIsOpen || n.isFocused) && {
      outline: `3px dotted ${r.colors.cyan[500]}`
    },
    transition: "none"
  }),
  dropdownIndicator: (o) => ({
    ...o,
    color: r.colors.neutral[900],
    ":hover": { color: r.colors.neutral[900] }
  }),
  input: (o) => ({
    ...o,
    color: r.colors.neutral[900],
    margin: 0,
    padding: 0
  }),
  indicatorSeparator: (o) => ({
    ...o,
    backgroundColor: r.colors.neutral[200]
  }),
  menu: (o) => ({
    ...o,
    borderColor: r.colors.neutral[200],
    borderRadius: 0,
    color: r.colors.neutral[900],
    zIndex: "10"
  }),
  menuPortal: (o) => ({
    ...o,
    zIndex: "10"
  }),
  multiValue: (o, n) => ({
    ...o,
    backgroundColor: r.colors.neutral[200],
    pointerEvents: n.isDisabled && "none"
  }),
  multiValueLabel: (o) => ({
    ...o,
    padding: "0 3px"
  }),
  multiValueRemove: (o) => ({
    ...o,
    ":hover": {
      backgroundColor: r.colors.neutral[900],
      color: r.colors.white
    }
  }),
  option: (o, n) => ({
    ...o,
    ":active": {
      color: r.colors.white,
      backgroundColor: r.colors.blue[500]
    },
    ...n.isFocused && {
      backgroundColor: r.colors.blue[100],
      cursor: "pointer"
    },
    ...n.isSelected && {
      backgroundColor: r.colors.blue[500]
    }
  }),
  placeholder: (o) => ({
    ...o,
    color: r.colors.neutral[300],
    whiteSpace: "nowrap"
  }),
  singleValue: (o) => ({
    ...o,
    color: r.colors.neutral[900]
  }),
  valueContainer: (o) => ({
    ...o,
    padding: `calc(${r.spacing[2]} - 0.2rem) ${r.spacing[2]}`
  })
}, p = y(
  ({
    ariaDescribedby: o,
    ariaLabel: n,
    className: b,
    defaultValue: c,
    disabled: m,
    id: g,
    isMulti: d,
    name: f,
    onChange: i,
    options: l = [],
    placeholder: C,
    validations: t,
    value: s
  }, I) => {
    const S = O(), h = u(() => d ? l.filter((e) => s == null ? void 0 : s.includes(e.value)) : l.find((e) => e.value === s) || null, [l, s]), w = u(() => d ? l.filter((e) => c == null ? void 0 : c.includes(e.value)) : l.find((e) => e.value === c) || null, [l, c]), k = (e) => {
      i == null || i(
        d ? (e || []).map((x) => x.value) : (e == null ? void 0 : e.value) || null
      );
    };
    return /* @__PURE__ */ D(
      R,
      {
        "aria-describedby": o,
        "aria-label": n,
        "aria-required": !!(t != null && t.required) || !!(t != null && t.minOptions),
        className: b,
        components: { DropdownIndicator: null },
        defaultValue: c && w,
        instanceId: S,
        inputId: g,
        isClearable: !0,
        isDisabled: m,
        isMulti: d,
        isOptionDisabled: (e) => e.disabled,
        name: f,
        onChange: k,
        options: l,
        placeholder: C,
        ref: I,
        styles: a,
        value: s === void 0 ? void 0 : h
      }
    );
  }
);
p.displayName = "SelectInput";
p.styles = a;
export {
  p as default
};
